module.exports = __webpack_public_path__ + "img/wizard_from_blocks.536e9783.png";